<template>
  <div class="col-lg-12">
    <div class="lesiurpackages_hotelsbox domestic_hotelsbox liveshow-box" :class="isBig && 'big'">
      <img :src="imageUrl"
        width=""
        height=""
        :alt="item.name"
        v-bind="mainProps"
        onerror="this.src='assets/img/lesiurpackages_hotelsimg6.jpg'"
      />
      <div class="lesiurpackages_hotelstextbox">

        <h3>{{ item.name }}</h3>
        <p v-if="item.checkinDate && item.checkoutDate" class="item-sub-title">
          <i class="fa fa-calendar-alt"></i> <span dir="ltr">{{ changeDateFormat(item.checkinDate) }} - {{ changeDateFormat(item.checkoutDate) }}</span>
        </p>
        <a v-if="isLanding || item.isLiveshowProduct" :href="productPageLink" :target="item.isLiveshowProduct ? '_blank' : '_self'"><div class="place btn-primary">{{ $t("home.domestic-order-button") }}</div></a>
        <router-link v-else :to="productPageLink"><div class="place btn-primary">{{ $t("home.domestic-order-button") }}</div></router-link>

        <div class="d-flex w-100 d-inline-block" :class="isRTLPage ? 'right-align' : 'left-align'">
          <div class="clock">
            <p v-if="item.artists"><i class="fa fa-check"></i> {{ $t("home.shows-of") }} : {{ item.artists }}</p>
            <p v-if="item.checkinDate && item.checkoutDate">
                <i class="fa fa-check"></i>
                {{$t("home.total-night")}}: {{ calcNight(item.checkoutDate, item.checkinDate) }} {{ (calcNight(item.checkoutDate, item.checkinDate) > 1) ? $t("home.nights") : $t("home.night") }}
            </p>
            <p v-if="item.sizes"><i class="fa fa-check"></i> {{ item.sizes }}</p>
          </div>
          <div class="price-wrapper align-items-center" :class="(device==='desktop') && isBig ? 'd-inline-flex': 'd-inline-block'" style="width:30%;">
            <p class="price">
              <span class="currency-symbol">₪</span><strong>{{discountedPrice}}</strong>
            </p>
            <p style="font-size:0.8rem;"> {{$t("home.total-price-for-the-package")}} </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateLesiurtabItem from './TemplateLesiurtabItem';

export default {
  name: 'LesiurtabItemTheme3',
  mixins: [TemplateLesiurtabItem],
};
</script>

<style scoped>
.liveshow-box {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border: 2px solid rgba(102, 126, 234, 0.2);
}

.liveshow-box:hover {
  border-color: rgba(102, 126, 234, 0.5);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.2);
}

.liveshow-phone {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
}

.liveshow-phone:hover {
  text-decoration: underline;
}

.liveshow-box .place {
  padding: 8px 10px;
  content: "";
  background: #005ca3;
  color: #fff;
  text-align: center;
  text-transform: capitalize;
  border-radius: 10px;
  z-index: 91;
  width: 120px;
  margin: 10px auto;
  border: 1px solid rgb(255 255 255 / 0.5);
  font-weight: bold;
}

.liveshow-box .place:hover {
  text-decoration: none;
}

.liveshow-box .disc {
  background: linear-gradient(135deg, #ff0000 0%, #cc0000 100%);
}

/* Inherit all other styles from Theme0 */
.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox div.clock{
  min-width: 70%;
}
.lesiurpackages_hotelsbox .right-align div.clock{
  border-left: 1px solid rgba(255, 255, 255, 0.37);
  direction: rtl;
}
.lesiurpackages_hotelsbox .left-align div.clock{
  border-left: none;
  margin-left: 0px;
  direction: ltr;
}
.lesiurpackages_hotelsbox .right-align div.price-wrapper{
  direction: rtl;
}
.lesiurpackages_hotelsbox .left-align div.price-wrapper{
  border-left: 1px solid rgba(255, 255, 255, 0.37);
  padding-left: 10px;
  direction: ltr;
}
.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox div.clock p:first-child{
  margin-top: revert;
}
.lesiurpackages_hotelsbox:not(.big) .lesiurpackages_hotelstextbox div.clock{
  width:80%;
}
.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox .item-sub-title{
  text-align:center;
  margin-bottom: 10px;
  margin-top: 10px;
  font-weight: 600;
}
.price{
  padding-top: 20px;
}
.place {
  padding: 8px 10px;
  content: "";
  background: #005ca3;
  color: #fff;
  text-align: center;
  text-transform: capitalize;
  border-radius: 10px;
  z-index: 91;
  width: 120px;
  margin: 10px auto;
  border: 1px solid rgb(255 255 255 / 0.5);
  font-weight: bold;
}
.lesiurpackages_hotelstextbox a:hover {
  text-decoration: none;
}

.domestic_hotelsbox{
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
  background: whitesmoke;
  box-shadow: #e0dede 0.5px 0.5px 5px;
}

.domestic_hotelstextbox{
  background: white;
  padding-bottom: 20px;
}

.lesiurpackages_hotelsbox.domestic_hotelsbox .place {
  width: fit-content;
}
.domestic_hotelsbox.lesiurpackages_hotelsbox:not(.big) .lesiurpackages_hotelstextbox div.clock{
  width: auto;
}
.domestic_hotelsbox.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox div.clock p{
  white-space: break-spaces;
  display: flex;
  margin-bottom: 3px;
}
.domestic_hotelsbox.lesiurpackages_hotelsbox img {
  filter: brightness(0.8);
}
.domestic_hotelsbox.lesiurpackages_hotelsbox:hover img {
  filter: brightness(1);
}
.domestic_hotelsbox.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox .d-inline-block p {
  font-size: 0.9rem;
}
.domestic_hotelsbox.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox div.clock i {
  margin-left: 5px;
}

.domestic_hotelsbox.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox .remark {
  font-size: 17px;
  color: #FFFFFF;
  direction: rtl;
  line-height: 15px;
  text-align: justify;
}

@media (max-width: 991px) {
  .lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox {
    text-align: center;
  }
}

@media (min-width: 480px) {
  .lesiurpackages_hotelsbox.big .lesiurpackages_hotelstextbox .item-sub-title{
    margin-bottom: 130px;
  }
  .lesiurpackages_hotelsbox.big h3{
    font-size: 3em;
  }
  .lesiurpackages_hotelsbox.big .lesiurpackages_hotelstextbox .item-sub-title{
    font-size: 2em;
  }
  .lesiurpackages_hotelsbox.big .place{
    padding: 10px 10px;
    font-size: 1.2rem;
  }
  .lesiurpackages_hotelsbox:not(.big) .lesiurpackages_hotelstextbox .d-inline-block p{
    line-height: 1em;
  }
}

.lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox div.clock p{
  white-space: nowrap;
}

@media (max-width: 480px) {
  .lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox .d-inline-block p {
    font-size: 0.9em;
  }
  .lesiurpackages_hotelsbox {
    height: 350px;
  }
  .lesiurpackages_hotelsbox.big .currency-symbol{
    font-size: initial;
  }
  .lesiurpackages_hotelsbox .lesiurpackages_hotelstextbox{
    padding: 4px
  }
}
</style>
